<template>
  <div class="headers col-md-12 fixed-top ">
    <nav class="navbar navbar-expand-md navbar-dark">
      <div class="container">
        <!-- 高亮logo -->
        <a href="#" class="navbar-brand"><img src="../../assets/imgs/logo.png" alt=""></a>
        <!-- 折叠按钮 -->
        <button type="button" class="navbar-toggler" data-toggle="collapse" data-target="#idname">
          <span class="navbar-toggler-icon"></span>
        </button>
        <!-- 折叠菜单 -->
        <div class="collapse navbar-collapse" id="idname">
          <ul class="navbar-nav justify-content-between align-items-center">
            <!-- 链接文本 -->
            <li class="nav-item">
              <router-link class="nav-link" :to="{ name: 'home' }" :class="[isactive==1?'active':'']">
                首页
              </router-link>
            </li>
            <li class="nav-item">
              <router-link class="nav-link" :to="{ name: 'projectcase' }" :class="[isactive==2?'active':'']">
                项目案例
              </router-link>

            </li>
            <li class="nav-item">
              <router-link class="nav-link" :to="{ name: 'custom' }" :class="[isactive==3?'active':'']">
                定制开发
              </router-link>

            </li>
            <li class="nav-item">
              <router-link class="nav-link" :to="{ name: 'newscenter' }" :class="[isactive==4?'active':'']">
                新闻中心
              </router-link>

            </li>
            <li class="nav-item">
              <router-link class="nav-link" :to="{ name: 'about' }" :class="[isactive==5?'active':'']">
                关于我们
              </router-link>

            </li>
            <li class="nav-item">
              <div class="official-account">关注微信公众号</div>
            </li>
          </ul>
        </div>
      </div>
    </nav>
  </div>
</template>

<script>
export default {
  props: {
    isactive: {
      type: Number,
      default: 0
    }
  }

}
</script>

<style lang="scss" scoped>
.headers {
  padding: 0;
}
.navbar {
  height: 80px;
  background-color: rgba(14, 20, 34);
  padding: 0;
}
// .bg-dark{
//     background-color: rgba(14, 20, 34) !important;
// }

.navbar-nav {
  width: 100%;
}
.nav-link {
  font-size: 18px;
  font-family: Source Han Sans SC;
  font-weight: 500;
  color: #9fa3ac !important;
  position: relative;
}
.nav-link:hover,
.active {
  color: #1966ff !important;
}
.nav-link:hover::after,
.active::after {
  position: absolute;
  content: "";
  width: 100%;
  height: 2px;
  background: #1966ff;
  bottom: 6px;
  left: 0;
}
.official-account {
  width: 120px;
  height: 32px;
  line-height: 32px;
  background: #1a2233;
  border-radius: 4px;
  font-size: 14px;
  font-family: Source Han Sans SC;
  font-weight: 400;
  color: #7a859c;
  position: relative;
}
.official-account:hover::after {
  visibility: visible;
  position: absolute;
  top: 40px;
  left: 0;
  content: "";
  background: url(../../assets/imgs/official-account.png);
  width: 123px;
  height: 123px;
  z-index: 999;
}
.official-account:hover {
  cursor: pointer;
  color: #ffffff;
  background-color: #1966ff;
}
.container {
  background-color: rgba(14, 20, 34);
}
@media (min-width: 1200px) {
  .container {
    max-width: 1200px;
  }
  .navbar-brand {
    margin-right: 200px !important;
  }
}
@media (max-width: 768px) {
  .navbar-expand-md > .container,
  .navbar-expand-md > .container-fluid,
  .navbar-expand-md > .container-lg,
  .navbar-expand-md > .container-md,
  .navbar-expand-md > .container-sm,
  .navbar-expand-md > .container-xl {
    padding: 0.5rem 1rem 1rem !important;
  }
  .navbar-brand {
    margin-right: 0;
  }
}
</style>
